<template>
  <el-dialog
    title="修改费用"
    :visible.sync="visible"
    width="600px"
    :before-close="handleClose"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <!-- 费用类别改为文本框（适配文本输入场景） -->
      <el-form-item label="费用类别" prop="feeType">
        <el-input
          v-model="form.feeType"
          placeholder="请输入费用类别"
          class="w-full"
        ></el-input>
      </el-form-item>
      <el-form-item label="费用明细" prop="feeDetail">
        <el-input
          v-model="form.feeDetail"
          placeholder="请输入费用明细"
        ></el-input>
      </el-form-item>
      <el-form-item label="费用金额" prop="feeAmount">
        <el-input-number
          v-model="form.feeAmount"
          :min="0"
          precision="2"
          placeholder="请输入费用金额"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="支付时间" prop="payTime">
        <el-date-picker
          v-model="form.payTime"
          type="datetime"
          placeholder="选择支付时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          class="w-full"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="form.remark"
          type="textarea"
          :rows="3"
          placeholder="请输入备注"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
// 移除getFeeTypes（不再需要下拉列表），保留updateFee并确保接口参数对齐
import { updateFundPayment } from "@/api/fee/fundPaymentApi";

export default {
  name: "EditFee",
  data() {
    return {
      visible: false,
      loading: false,
      form: {
        // 核心修复：替换feeId为fundPaymentId（数据库主键）
        fundPaymentId: "",
        feeType: "",
        feeDetail: "",
        feeAmount: 0,
        payTime: "",
        remark: "",
        communityId: "", // 园区ID（防跨园区修改）
        statusCd: "0", // 补充：有效数据标识（软删除用）
      },
      rules: {
        // 调整费用类别校验规则（文本框失焦触发）
        feeType: [
          { required: true, message: "请输入费用类别", trigger: "blur" },
        ],
        feeDetail: [
          { required: true, message: "请输入费用明细", trigger: "blur" },
        ],
        feeAmount: [
          { required: true, message: "请输入费用金额", trigger: "blur" },
        ],
        payTime: [
          { required: true, message: "请选择支付时间", trigger: "change" },
        ],
      },
    };
  },
  mounted() {
    // 移除获取下拉列表的逻辑（费用类别改为文本框）
  },
  methods: {
    async open(fee) {
      this.visible = true;
      // 核心修复：从入参中获取正确的主键fundPaymentId
      const communityId = this.$parent.getCommunityId
        ? this.$parent.getCommunityId()
        : "";

      // 回显数据（对齐后端字段）
      try {
        this.form = {
          fundPaymentId: fee.fundPaymentId, // 替换feeId为fundPaymentId
          feeType: fee.feeType || "", // 费用类别（文本值）
          feeDetail: fee.feeDetail || "",
          feeAmount: Number(fee.feeAmount) || 0, // 确保数字类型
          payTime: fee.payTime || "",
          remark: fee.remark || "",
          communityId: communityId,
          statusCd: "0", // 保持数据有效
        };
      } catch (error) {
        console.error("获取费用详情失败:", error);
        this.$message.error("加载费用详情失败");
      }
    },
    handleClose() {
      this.visible = false;
      this.resetForm();
    },
    resetForm() {
      // 重置时同步修改主键字段
      this.form = {
        fundPaymentId: "",
        feeType: "",
        feeDetail: "",
        feeAmount: 0,
        payTime: "",
        remark: "",
        communityId: "",
        statusCd: "0",
      };
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate();
        this.loading = true;
        // 调用修改接口，传递正确的参数（含fundPaymentId）
        await updateFundPayment(this.form);
        this.$message.success("修改成功");
        this.handleClose();
        this.$emit("handleRefreshFee"); // 通知列表刷新
      } catch (error) {
        if (error !== false) console.error("修改失败:", error);
        this.$message.error("修改失败");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.w-full {
  width: 100%;
}
</style>
